import { SVGProps, Ref, forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const TriangleIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={26}
    fill="none"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ?
      <title id={titleId}>{title}</title>
    : null}
    <path fill="#242838" d="M23 13 .5 25.99V.01L23 13Z" />
  </svg>
)
const ForwardRef = forwardRef(TriangleIcon)
export default ForwardRef
